export let dateTypeFormat = function (fmt, date) {
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (const k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
};

export const testVideo = function (url) {
  // 常见的视频文件扩展名
  const videoExtensions = [
    "mp4",
    "webm",
    "ogg",
    "mov",
    "avi",
    "wmv",
    "flv",
    "mkv",
    "mpeg",
    "mpg",
    "3gp",
    "m4v",
  ];

  // 移除URL中的查询参数和哈希部分
  const urlWithoutParams = url.split("?")[0].split("#")[0];

  // 提取文件扩展名
  const extensionMatch = urlWithoutParams.match(/\.([^.]+)$/i);
  if (!extensionMatch) {
    return false;
  }

  const extension = extensionMatch[1].toLowerCase();

  // 检查扩展名是否在视频扩展名列表中
  return videoExtensions.includes(extension);
};

/**
 * 针对"数字/数字/数字/UUID"格式的压缩工具
 * 确保压缩结果≤32位字符
 */
export const SimplifiedSceneCompressor = class {
  // URL安全的64进制字符集
  static chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

  /**
   * 压缩参数
   * @param {string} str 原始参数，格式为"数字/数字/数字/UUID"
   * @returns {string} 压缩后的字符串(≤24位)
   */
  static compress(str) {
    // 1. 拆分参数
    const [p1, p2, p3, uuid] = str.split("/");
    if (!p1 || !p2 || !p3 || !uuid) {
      throw new Error('参数格式必须为"数字/数字/数字/UUID"');
    }

    // 2. 转换数字为整数
    const num1 = parseInt(p1, 10);
    const num2 = parseInt(p2, 10);
    const num3 = parseInt(p3, 10);

    // 3. 处理UUID(移除横线)
    const uuidHex = uuid.replace(/-/g, "");

    // 4. 构建二进制缓冲区(3个数字各1字节 + 16字节UUID = 19字节)
    const buffer = new ArrayBuffer(19);
    const view = new DataView(buffer);

    // 存储三个数字(各占1字节)
    view.setUint8(0, num1);
    view.setUint8(1, num2);
    view.setUint8(2, num3);

    // 存储UUID(16字节)
    for (let i = 0; i < 16; i++) {
      view.setUint8(3 + i, parseInt(uuidHex.substr(i * 2, 2), 16));
    }

    // 5. 转换为64进制字符串
    return this.bufferToBase64(buffer);
  }

  /**
   * 解压参数
   * @param {string} str 压缩后的字符串
   * @returns {string} 原始参数
   */
  static decompress(str) {
    // 1. 转换为二进制缓冲区
    const buffer = this.base64ToBuffer(str);
    const view = new DataView(buffer);

    // 2. 提取三个数字
    const p1 = view.getUint8(0).toString(10);
    const p2 = view.getUint8(1).toString(10);
    const p3 = view.getUint8(2).toString(10);

    // 3. 提取并格式化UUID
    let uuidHex = "";
    for (let i = 0; i < 16; i++) {
      uuidHex += view
        .getUint8(3 + i)
        .toString(16)
        .padStart(2, "0");
    }
    const uuid = this.formatUuid(uuidHex);

    // 4. 组合成原始格式
    return `${p1}/${p2}/${p3}/${uuid}`;
  }

  /**
   * ArrayBuffer转64进制字符串
   */
  static bufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let result = "";
    let bits = 0;
    let value = 0;

    for (const byte of bytes) {
      value = (value << 8) | byte;
      bits += 8;

      while (bits >= 6) {
        result += this.chars[(value >>> (bits - 6)) & 0x3f];
        bits -= 6;
      }
    }

    // 处理剩余的位
    if (bits > 0) {
      result += this.chars[(value << (6 - bits)) & 0x3f];
    }

    return result;
  }

  /**
   * 64进制字符串转ArrayBuffer
   */
  static base64ToBuffer(str) {
    const buffer = new ArrayBuffer(19);
    const bytes = new Uint8Array(buffer);
    let byteIndex = 0;
    let bits = 0;
    let value = 0;

    for (const char of str) {
      const index = this.chars.indexOf(char);
      if (index === -1) throw new Error("无效的压缩字符");

      value = (value << 6) | index;
      bits += 6;

      while (bits >= 8) {
        bytes[byteIndex++] = (value >>> (bits - 8)) & 0xff;
        bits -= 8;
      }
    }

    return buffer;
  }

  /**
   * 格式化UUID为标准格式
   */
  static formatUuid(hex) {
    return [
      hex.substr(0, 8),
      hex.substr(8, 4),
      hex.substr(12, 4),
      hex.substr(16, 4),
      hex.substr(20, 12),
    ].join("-");
  }
};

/**
 * 以，,空格分割字符串，只能分割成两段
 */
export const splitVision = function (str = "") {
  let splitIndex = str.length - 1;
  if (str.indexOf(",") !== -1) {
    splitIndex = str.indexOf(",");
    return [str.slice(0, splitIndex), str.slice(splitIndex + 1)];
  } else if (str.indexOf("，") !== -1) {
    splitIndex = str.indexOf("，");
    return [str.slice(0, splitIndex), str.slice(splitIndex + 1)];
  } else if (str.indexOf(" ") !== -1) {
    splitIndex = str.indexOf(" ");
    return [str.slice(0, splitIndex), str.slice(splitIndex + 1)];
  } else {
    return [str];
  }
};
